import { Component, Input } from '@angular/core';
import { ClientStatisticsByMonth } from '@classes/client-statistics/client-statistics-by-month';
import { ClientStatisticsByYear } from '@classes/client-statistics/client-statistics-by-year';

@Component({
  selector: 'app-crm-charts',
  templateUrl: './crm-charts.component.html',
  styleUrls: ['./crm-charts.component.scss']
})
export class CRMChartsComponent {
  @Input() clientStatisticsByMonth: ClientStatisticsByMonth;
  @Input() clientStatisticsByYear: ClientStatisticsByYear[];
}
